// @flow
import React from 'react';
import ExclamationCircleIcon from 'mz-icons/exclamation-circle';
import { FormattedMessage } from 'mz-intl';
import { Container, Icon, HoldPercentageWrapper } from './elements';
import messages from 'app/components/book-trip/messages.intl';

// types
type Props = {
  mobile: boolean,
};

const HoldPercentage = () => (
  <HoldPercentageWrapper>
    <FormattedMessage message={messages.ON_DEMAND_HOLD_PERCENTAGE} />
  </HoldPercentageWrapper>
);

const OnDemandDisclaimer = ({ mobile }: Props) => {
  return (
    <FormattedMessage
      message={messages.ON_DEMAND_DISCLAIMER}
      values={{ holdPercentage: <HoldPercentage /> }}
    >
      {(disclamer, holdPercentage, rest) => (
        <Container $mobile={mobile}>
          <Icon>
            <ExclamationCircleIcon />
          </Icon>
          {disclamer} {holdPercentage} {rest}
        </Container>
      )}
    </FormattedMessage>
  );
};

export default OnDemandDisclaimer;
